import '@ungap/custom-elements'
import autosize from 'autosize'

export class AutoSize extends HTMLTextAreaElement {
  constructor() {
    super()
    autosize(this)
  }
}
